import ApiClient from "Store/client";

export const fetchClassroomAssignmentProgressApi = (batchId: string) =>
  ApiClient<{ total: number; processed: number; failed: number; finished: boolean }>(
    `api/classrooms/assignment-progress/${batchId}`
  );
